import { } from 'googlemaps';
import InfoBox from 'google-maps-infobox';

export class GoogleMapsLibrary {

    public static googlemaps_initialize() {

      var secheltLoc = new google.maps.LatLng(47.06749, 15.44581);

		var styles: google.maps.MapTypeStyle[] = [ { "stylers": [ { "hue": "#ffa200" }, { "saturation": -100 } ] }, { "elementType": "labels.text.fill", "stylers": [ { "color": "#000000" } ] }, { "featureType": "landscape", "stylers": [ { "color": "#fffad1" } ] }, { "featureType": "landscape.man_made", "elementType": "geometry.fill", "stylers": [ { "color": "#fffad1" } ] }, { "featureType": "landscape.natural", "elementType": "geometry.fill", "stylers": [ { "color": "#fffad1" } ] }, { "featureType": "landscape.natural.landcover", "elementType": "geometry.fill", "stylers": [ { "color": "#fffad1" } ] }, { "featureType": "landscape.natural.terrain", "elementType": "geometry.fill", "stylers": [ { "color": "#fffad1" } ] }, { "featureType": "poi", "stylers": [ { "color": "#000" }, { "visibility": "simplified" } ] } ];
		var myMapOptions: google.maps.MapOptions =  {
         zoom: 16,
         center: secheltLoc,
         mapTypeId: google.maps.MapTypeId.ROADMAP,
         styles: styles,
         scrollwheel: false
			};
			var theMap = new google.maps.Map(document.getElementById("map"), myMapOptions);

			var marker = new google.maps.Marker({
				position: new google.maps.LatLng(47.06749, 15.44581),
				icon: '/wp-content/themes/Theaterholding/images/marker.png',
				map: theMap,
				title: 'Bühnen Graz GmbH'
			});

			var box = document.createElement("div");
			box.classList.add("mapsBox");

			var boxCompanyname = document.createElement("div");
			boxCompanyname.innerHTML = "Bühnen Graz GmbH";
			boxCompanyname.classList.add("fontBrandon");

			var boxAddress = document.createElement("div")
			boxAddress.innerHTML = "Gleisdorfer Gasse 10a<br />A-8010 Graz";
			boxAddress.classList.add("fontBrandon");

			box.appendChild(boxCompanyname)
			box.appendChild(boxAddress)

			var myOptions = {
				 content: box
				,disableAutoPan: false
				,maxWidth: 0
				,pixelOffset: new google.maps.Size(20, 0)
				,zIndex: null
				,boxStyle: {
				  background: "none"
				  ,opacity: 0.75
				  ,width: "300px"
				 }
				,closeBoxMargin: "10px 2px 2px 2px"
				,closeBoxURL: "/wp-content/themes/Theaterholding/images/close.png"
				,infoBoxClearance: new google.maps.Size(1, 1)
				,isHidden: false
				,pane: "floatPane"
				,enableEventPropagation: false
			};

			google.maps.event.addListener(marker, "click", function (e) {
				ib.open(theMap, this);
      });


      var ib = new InfoBox(myOptions);
			ib.open(theMap, marker);
    }
}
